import { useSyncExternalStore } from 'react';
import { isConnectivityLost, subscribeConnectivity } from '@clarix/utils';

/** Reachable internet, not just `navigator.onLine`: a Wi-Fi with no uplink reads as offline once probed. */
export function useOnline(): boolean {
  return useSyncExternalStore(
    subscribeConnectivity,
    () => !isConnectivityLost(),
    () => true,
  );
}

function subscribeVisibility(onChange: () => void): () => void {
  document.addEventListener('visibilitychange', onChange);
  return () => document.removeEventListener('visibilitychange', onChange);
}

/** The tab is on screen; a hidden tab's timers and polls are throttled. */
export function usePageVisible(): boolean {
  return useSyncExternalStore(
    subscribeVisibility,
    () => document.visibilityState === 'visible',
    () => true,
  );
}
